<template>
	<div class="left-panel">
		<div class="page-tab-section">

			<div class="tab-row" :class="{'active':(active === 'home')}">
				<b-link :to="{ name: 'employerHome', params: { uuid: uuid } }" class="home-tab">
					<span class="title">Home</span>
				</b-link>
			</div>

			<div class="tab-row">
				<b-link :to="{ name: 'employerAllCategories', params: { uuid: uuid } }">
					<span class="title">Opportunities</span>
				</b-link>
			</div>
			<div class="tab-row sub-tab-row" v-for="(value, key) in categories">
				<b-link :to="{ name: 'employerCategory', params: { uuid: uuid, category: key } }">
					<span class="title">{{key}}</span>
				</b-link>
			</div>

			<div class="tab-row">
				<b-link :class="{'active':(active === 'report')}" :to="{ name: 'employerReport', params: { uuid: uuid } }" class="report-tab">
					<span class="title">Reports</span>
				</b-link>
			</div>

		</div>
	 </div>

</template>

<script>
import '../../../assets/module/css/common/pgLftTree.min.css'
import { mapState } from 'vuex'

export default {
  name: 'employerMenu',
  props: ['uuid', 'active'],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
  },

  updated () {
  },

  methods: {
  },

  computed: {
    ...mapState({
      'employer': state => state.employer.employer,
      'categories': state => state.employer.categories
    })
  },

  watch: {
  }
}
</script>
<style>
	.collapsed > .collapsed,
	:not(.collapsed) > .expand {
	  display: none;
	}
</style>



// WEBPACK FOOTER //
// src/app/employer/components/EmployerMenu.vue